/*
 * @Author: wangshengqiang
 * @Date: 2021-04-27 11:28:29
 * @LastEditTime: 2021-04-27 16:51:58
 * @LastEditors: wangshengqiang
 * @Description: 保障期间和缴费期间
 */
import React, { useEffect, useState } from 'react';
import RowRadioList from '../RowRadioList';
import './index.less';
export default function ChooseEnumPeriod(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RowRadioList, props));
}